module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "ApplyPartnerView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ApplyPartnerView!./src/pages/Register/ApplyPartner/index.js
// module id = 1334
// module chunks = 418